module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./ChatListView.js"));
	}, "ChatListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ChatListView!./src/pages/TIM/ChatList/ChatListView.js
// module id = 2243
// module chunks = 367